import { SkyttaComponentIds } from '../SkyttaComponentIds';
import type { ComponentDeserializer,  SerializableComponent } from '@inter-ikea-core/core';

const componentSerializationKey = 'RoomDimensionOptionsComponent';

export class RoomDimensionOptionsComponentDeserializer implements ComponentDeserializer {
  thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
  canHandle(serializationKey: string) {
    return serializationKey === componentSerializationKey;
  }

  deserialize(serializationKey: string, json: any) {
    const data: RoomDimensionOptionsComponent = JSON.parse(json.toString());
    switch (serializationKey) {
      case componentSerializationKey:
        return new RoomDimensionOptionsComponent(data.width, data.height, data.depth);
    }
    return null;
  }
}

/**
 * Stores which room size choice has been made
 */
export class RoomDimensionOptionsComponent implements SerializableComponent {
  public static readonly ID = SkyttaComponentIds.RoomDimensionOptionsComponentId;
  public readonly typeId: number = RoomDimensionOptionsComponent.ID;
  public readonly serializable: boolean = true;
  public readonly doStoreInSnapshot: boolean = true;

  public readonly width: number;
  public readonly height: number;
  public readonly depth: number;

  constructor(width: number, height: number, depth: number) {
    this.width = width;
    this.height = height;
    this.depth = depth;
  }

  serializationKey(): string {
    return componentSerializationKey;
  }

  toJson(parse: (json: string) => string): string  {
    return parse(JSON.stringify(this));
  }

  eq(other: RoomDimensionOptionsComponent): boolean {
    return this.width === other.width && this.height === other.height && this.depth === other.depth;
  }
}
